export const ARIZONA = {
  name: "Arizona",
  label: "Arizona",
};

export const FLORIDA = {
  name: "Florida",
  label: "Florida",
};

export const GEORGIA = {
  name: "Georgia",
  label: "Georgia",
};

export const MICHIGAN = {
  name: "Michigan",
  label: "Michigan",
};

export const NORTH_CAROLINA = {
  name: "North Carolina",
  label: "North Carolina",
};

export const WISCONSIN = {
  name: "Wisconsin",
  label: "Wisconsin",
};

export const CONFLICT_RESOLUTION_PROGRAM = {
  name: "CRP                                    (All states)",
  label: "CRP All States",
};

export const DEMOCRACY_PROGRAM = {
  name: "DP                            (All states)",
  label: "DP All States",
};

export const PARTNERSHIPS = {
  name: "PARTNERSHIPS",
  label: "Partnerships",
  icon: "fa-regular fa-handshake",
  spreadsheet_name: "# of new partnerships",
  description:
    "# of new partnerships formed with entities (e.g., organizations, associations, service clubs) to advance STAR objectives",
};

export const NEW_MEMBERS = {
  name: "NEW_MEMBERS",
  label: "New Members",
  icon: "fa-solid fa-user-plus",
  spreadsheet_name: "# of new members",
  description: "# of new people actively engaged in promoting STAR objectives",
};

export const TOTAL_MEMBERS = {
  name: "TOTAL_MEMBERS",
  label: "Total Members",
  icon: "fa-solid fa-users",
  spreadsheet_name: "Total # of members",
  description:
    "Total # of people actively engaged in promoting STAR objectives",
};


export const MEMBERS_TRAINED = {
  name: "MEMBERS_TRAINED",
  label: "Members Trained",
  icon: "fa-solid fa-screwdriver-wrench",
  spreadsheet_name: "# of members trained",
  description: "Total number of people trained",
};

export const SOCIAL_FOLLOWING = {
  name: "SOCIAL_FOLLOWING",
  label: "Social Following",
  icon: "fa-regular fa-thumbs-up",
  //long_label: "Candidate Principle Endorsements",
  spreadsheet_name: "# of new endorsements of the candidate principles",
  description:
    "# of Facebook and other social media followers",
};

export const TASK_FORCE = {
  name: "TASK_FORCE",
  label: "Task Forces",
  long_label: "Task Force Initiatives",
  icon: "fa-solid fa-people-roof",
  spreadsheet_name: "# of new initiatives with task forces",
  description:
    "# of initiatives that have task forces or alternative structures to engage a broad swath of individuals in such critical tasks as outreach, event planning, resource generation, CP advocacy",
};

export const NEOs = {
  name: "NEOs",
  label: "NEOs",
  long_label: "New Election Observers",
  icon: "fa-solid fa-chalkboard-user",
  spreadsheet_name: "# of election observers recruited & trained",
  description: "# of neutral election observers (NEOs) recruited and trained",
};

export const MEDIA_ENGAGEMENTS = {
  name: "MEDIA_ENGAGEMENTS",
  label: "Media Engagements",
  icon: "fa-solid fa-video",
  spreadsheet_name: "# of new media engagements",
  description: "# of media engagements about the STAR agenda",
};

export const SPEAKING_INVITATIONS = {
  name: "SPEAKING_INVITATIONS",
  label: "Speaking Invites",
  icon: "fa-solid fa-microphone-lines",
  long_label: "Speaking Invitations",
  spreadsheet_name: "# of new speaking invitations",
  description: "# of speaking invitations about the STAR agenda",
};

export const MEDIA_REACH = {
  name: "MEDIA_REACH",
  label: "Media Reach",
  icon: "fa-solid fa-eye",
  long_label: "Media Reach",
  spreadsheet_name: "media reach",
  description: "Total # of unique visitors per month (UVM) across outlets that ran print/online media hits",
};

export const CRP = {
  name: "CRP                                    (All states)",
  label: "Conflict Resolution Program",
  title: "CRP (All States)",
  short: "CRP",
};

export const DP = {
  name: "DP",
  label: "Democracy Program",
  title: "DP (All States)",
  short: "DP"
};

export const STAR = {
  name: "STAR",
  label: "STAR Program",
};

export const ALL_INDICATORS = [
  TOTAL_MEMBERS,
  NEW_MEMBERS,
  MEMBERS_TRAINED,
  //DP_MEMBERS_TRAINED,
  PARTNERSHIPS,
  SOCIAL_FOLLOWING,
  TASK_FORCE,
  MEDIA_ENGAGEMENTS,
  MEDIA_REACH,
  SPEAKING_INVITATIONS,
  NEOs,
];
export const CRP_INDICATORS = [
  TOTAL_MEMBERS,
  NEW_MEMBERS,
  MEMBERS_TRAINED,
  PARTNERSHIPS,
  SOCIAL_FOLLOWING,
  TASK_FORCE,
  MEDIA_ENGAGEMENTS,
  MEDIA_REACH,
  SPEAKING_INVITATIONS,
];
export const DP_INDICATORS = [
  PARTNERSHIPS,
  MEMBERS_TRAINED,
  NEOs,
  MEDIA_ENGAGEMENTS,
  SPEAKING_INVITATIONS,
];
export const STATES = [
  ARIZONA,
  FLORIDA,
  GEORGIA,
  MICHIGAN,
  NORTH_CAROLINA,
  WISCONSIN,
];
export const CRP_STATES = [
  CRP,
  ARIZONA,
  FLORIDA,
  GEORGIA,
  MICHIGAN,
  NORTH_CAROLINA,
  WISCONSIN,
];
export const PROGRAMS = [CRP, DP];

export const formattedResponse = (response) => ({
  ...response,
  rows: response.rows.map((row) => {

    const transformedRow = {};

    for (const key in row) {
      if (Object.hasOwnProperty.call(row, key)) {
        let value = row[key];

        if (key === "Month") {
          value = convertSSFDateToJSDate(value);
        } 
        
        if (value === "?" || value === "") {
          value = "-";
        }

        const indicator = ALL_INDICATORS.find(
          (indicator) => indicator.spreadsheet_name === key
        );
        const headerName = indicator ? indicator.label : key;

        transformedRow[headerName] = value;
      }
    }
    ALL_INDICATORS.forEach((indicator) => {
      const headerName = indicator.label;
      if (!transformedRow.hasOwnProperty(headerName)) {
        transformedRow[headerName] = "-";
      }
    });
    return transformedRow;
  }),
});

function convertSSFDateToJSDate(SSFDate) {
  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  const ssfDateMilliseconds = SSFDate * millisecondsPerDay;

  const startExcelDate = new Date("1899-12-31T00:00:00Z");
  return startExcelDate.getTime() + ssfDateMilliseconds;
}

export const getMonthOptions = (data) => {
  const monthOptions = [];
  if (data.length > 0) {
    const uniqueMonths = [
      ...new Set(data.map((item) => new Date(item.Month).getMonth())),
    ];
    uniqueMonths.forEach((month) => {
      const monthLabel = new Date(2000, month).toLocaleString(undefined, {
        month: "long",
      });
      monthOptions.push({ label: monthLabel, value: month });
    });
  }
  return monthOptions;
};

// Utility function to get year options
export const getYearOptions = (data) => {
  const yearOptions = [];
  if (data.length > 0) {
    const uniqueYears = [
      ...new Set(data.map((item) => new Date(item.Month).getFullYear())),
    ];
    uniqueYears.forEach((year) => {
      yearOptions.push({ label: year.toString(), value: year });
    });
  }
  return yearOptions;
};

export const baseColors = [
  "#22378C", // Blue
  "#7c91a2", // Grey
  "#A33600", // Red
  "#d59084", // Pale Brown
  "#0C141D", // Dark Blue
  "#E0C200", // Gold
  "#ff992b", // Yellow
  "#ffde19", // Light Blue
  "#FFADAD", // Peach
];
